<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class="s_flex_ali p-20 s_bf58 m-b-20">
        <a-button size='small' @click="()=>{$router.go(-1)}">
          <LeftOutlined />返回
        </a-button><p class="m-l-10">只可添加产品库中已上架商品，若需添加新商品，请到产品库中添加</p>  <a href="/product/libs/management/createProduct" target="_blank"> 前往产品库</a>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="产品名称" name='product_name'>
          <a-input v-model:value="search.product_name" style="width:280px" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="产品分类" name='product_category_id'>
          <a-cascader :options="cateList" :load-data="loadData" v-model:value="search.product_category_id" :field-names="{ label: 'group_name', value: 'id', children: 'child' }"  placeholder="请选择产品分类" change-on-select @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' >
        <template v-slot:product_name="{record}">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>
              <p class="s_omit2" style="width:200px">{{record.product_name}}</p>
            </template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
         <a-button  @click="recovery(record)" v-if="record.is_add_online_goods==0">
             添加商品
        </a-button>
         <a-button   v-else :disabled="true">
            已添加
        </a-button>
        </template>
      </a-table>
     <div style="text-align:right" class="m-t-10">
          <a-pagination show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
     </div>
    </a-card>
  </a-layout>
</template>
<script>
import {  LeftOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import {
  getProductCate,
} from "@/api/product";
import {getBaseProductList} from '@/api/online'
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  product_name: "",
  product_category_id: [],
  page: 1,
  limit: 10,
};
export default {
  components: {
    LeftOutlined,
  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      info: store.state.user.info,
      listLoading: false,
      time: [],
      total: 1,
      active: 1,
    });
    let columns = [
      {
        title: "ID",
        dataIndex: "product_id",
        key: "product_id",
        width: 100,
      },
      {
        title: "商品名称",
        dataIndex: "product_name",
        key: "product_name",
        width: 300,
        slots: { customRender: "product_name" },
      },
      {
        title: "商品分类",
        dataIndex: "product_category_name",
        key: "product_category_name"
      },

      {
        title: "价格/元",
        dataIndex: "product_price",
        key: "product_price",
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };



    const form = ref();
    const initData = async (values) => {
      state.listLoading = true;
      try {
       let res = await getBaseProductList({
         ...values,
         product_category_id:values.product_category_id.length?values.product_category_id[values.product_category_id.length-1]:''
       }).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
        // 获取分类
    const cateList = ref([]);
    const getCate = async () => {
      let cateResult = await getProductCate()
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(cateResult)) {
        cateList.value = cateResult.data;
      }
    };
    onMounted(() => {
      initData(search.value);
      getCate()
    });
    const $router=inject('$router')
    const recovery=(data)=>{
      $router.push({path:'/onlineOrder/productManage/createtwo',query:{product_id:data.product_id}})
    }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      form,
      cateList,
      recovery
    };
  },
};
</script>